export default "__VITE_ASSET__afbe74fa__"